import {spacing} from "@khanacademy/wonder-blocks-tokens";

export const toolbarHeight = spacing.xxxLarge_64;
